import { mapActions, mapState } from 'vuex'
import Actions from '@/constants/action'
import RouterName from '@/constants/route'
import { Notify } from 'vant'

export const logic = {
  data() {
    return {
      campaignCode: this.$route.query.code || this.$route.query.campaignCode,
      campaignId: this.$route.query.campaignId,
      eventId: this.$route.query.eventId,
      from: this.$route.query.from,
      type: this.$route.query.type
    }
  },
  methods: {
    ...mapActions({
      updateUserInfo: Actions.UPDATE_USER_LOCAL_INFO,
      getVerifyCode: Actions.GET_VERIFY_CODE,
      loginRequest: Actions.LOGIN,
      getCampaignIdByCode: Actions.GET_CAMPAIGN_ID_BY_CODE
    }),
    login(info) {
      if (!this.campaignCode && !this.campaignId) {
        return Notify({ message: '链接参数错误，请重新扫码', duration: 3 * 1000 })
      }
      this.loginRequest(info)
        .then(() => {
          this.$router.replace({
            name: RouterName.home,
            query: {
              eventCampaignId: this.campaignId,
              eventId: this.eventId
            }
          })
        })
    }
  },
  created() {
    if (!this.campaignCode && !this.campaignId) {
      return Notify({ message: '链接参数错误，请重新扫码', duration: 3 * 1000 })
    }
    if (this.campaignCode && this.from !== RouterName.publicEvent) {
      this.updateUserInfo({
        campaignCode: this.campaignCode
      })
      this.getCampaignIdByCode({ campaignCode: this.campaignCode })
        .then((d) => {
          this.campaignId = d.campaignId
          if (d.redirectUrl) {
            location.replace(d.redirectUrl)
          }
        })
    }
  },
  computed: {
    ...mapState(['userInfo', 'language', 'loading']),
    cLoading() {
      return this.loading.userInfoLoading || this.loading.verifyCodeLoading || this.loading.campaignIdLoading
    }
  }
}
